import { QuestionAttempts } from './question-attempts'

export const QuestionAttemptQuerySymbol = Symbol.for('QuestionAttemptQuery')

export interface QuestionAttemptQuery {
  query(questionIds: string[]): QuestionAttempts[]
}
